import React from 'react';

interface IconProps {
  className?: string;
  style?: React.CSSProperties;
  width?: string | number;
  height?: string | number;
  active?: boolean;
}

const WohnungNeubauIcon: React.FC<IconProps> = ({
  className,
  style,
  width = 48,
  height = 48,
}) => {
  return (
    <svg
      viewBox="566 500 40 40"
      width={width}
      height={height}
      fill="none"
      stroke="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M574 540V504C574 503.46 574 502.9 574.14 502.36C574.262 501.821 574.533 501.328 574.922 500.935C575.311 500.543 575.802 500.267 576.34 500.14C576.92 500 579.46 500 580 500H594C594.54 500 595.1 500 595.64 500.14C596.179 500.262 596.672 500.533 597.065 500.922C597.457 501.311 597.733 501.802 597.86 502.34C597.86 502.9 597.86 503.46 598 504V540H574Z"
      />
      <path
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M566 524V536C566 538.2 567.8 540 570 540H574V520H570C569.46 520 568.9 520 568.36 520.14C567.82 520.28 567.32 520.54 566.92 520.94C566.54 521.32 566.28 521.82 566.14 522.36C566.027 522.899 565.98 523.45 566 524Z"
      />
      <path
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M603.64 514.14C603.101 514.027 602.55 513.98 602 514H598V540H602C603.061 540 604.078 539.579 604.828 538.828C605.579 538.078 606 537.061 606 536V518C606 517.44 606 516.9 605.86 516.36C605.72 515.82 605.46 515.32 605.06 514.92C604.68 514.54 604.18 514.28 603.64 514.14Z"
      />
      <path
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M582 508H590"
      />
      <path
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M582 516H590"
      />
      <path
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M582 524H590"
      />
      <path
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M582 532H590"
      />
    </svg>
  );
};

export default WohnungNeubauIcon;
